import { Checkbox as PCheckbox, CheckboxProps as PCheckboxProps } from 'primereact/checkbox';
import React from 'react';

type CheckboxProps = PCheckboxProps & {
  name: string;
  label?: string | JSX.Element;
  error?: string | boolean;
};

export const Checkbox = ({ name, label, error, ...rest }: CheckboxProps) => {
  return (
    <>
      <div className="field-checkbox">
        <PCheckbox inputId={name} className={error ? 'p-invalid' : ''} {...rest} />
        {label && <label htmlFor={name}>{label}</label>}
      </div>
      <div className='mb-3'>{error && <small className="p-error mt-1 block">{error}</small>}</div>
    </>
  );
};
